import React, { ReactNode } from "react";

import "./style.scss";

export enum ColumnContainerLayouts {
    /** All children take up equal space. Works with any number of children */
    AUTO,
    /** First children takes up 2/3 of the space, the second child 1/3. Works for two children */
    TWO_ONE,
    /** First children takes up 1/3 of the space, the second child 2/3. Works for two children */
    ONE_TWO
}

const layoutClasses: { [key: string]: string | null } = {
    [ColumnContainerLayouts.AUTO]: null,
    [ColumnContainerLayouts.TWO_ONE]: "two_one",
    [ColumnContainerLayouts.ONE_TWO]: "one_two"
};

export interface Props {
    children: ReactNode;
    className?: string;
    spacing?: 0 | 16 | 24 | 32 | 64;
    layout?: ColumnContainerLayouts;
}

/**
 * Aligns immediate children horizontally in columns with a 32px gap.
 * On mobile, the alignment is vertical again.
 *
 * A maximum of three children per row is allowed. If more than three children are passed,
 * the component will wrap them automatically.
 */
export const ColumnContainer = ({ spacing = 24, children, className, layout = ColumnContainerLayouts.AUTO }: Props) => {
    const classNames = ["columnContainer", className];

    classNames.push(`s${spacing}`);

    if (layoutClasses[layout] !== null) {
        // @ts-ignore
        classNames.push(layoutClasses[layout]);
    }

    if (React.Children.count(children) > 3) {
        classNames.push("wrap");
    }

    return <div className={classNames.join(" ")}>{children}</div>;
};
